module.exports = __webpack_public_path__ + "static/media/expedia-bg.312e0cc6.jpg";